'use client';

import React from 'react';
import Image from 'next/image';
// import save20 from '../../../public/store/save-20-percent.jpg';
import { Play } from '../ui/Icons';
import HeadlessModal from '../shared/HeadlessModal';
import ReactPlayer from 'react-player';

const save = {
  de: 'So einfach kannst du mit LENTHO galaktisch gut sparen!',
  en: 'Saving money with LENTHO is so easy!',
};

type Props = {
  params: { locale: string };
  dictionary?: any;
  data?: any;
};

export default function TryNewAndSave({ params, data }: Props) {
  const lang = params.locale.split('-')[0] as 'en' | 'de';
  const sectionData = data?.value;

  return (
    <section className="relative w-full bg-[#9CE0EC] md:py-20">
      <div className="container flex w-full flex-col items-center justify-between p-10 lg:flex-row">
        <SaveVideo
          thumbnail={sectionData?.video_thubnail}
          videoUrl={sectionData?.video_url}
        />
        <h2 className="w-full text-center text-h2 font-semibold text-title lg:w-[30%] xl:text-left">
          {sectionData?.h2?.[lang] ?? save[lang]}
        </h2>
      </div>
    </section>
  );
}

function SaveVideo({
  thumbnail,
  videoUrl,
}: {
  thumbnail?: string;
  videoUrl?: string;
}) {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <div className="relative mb-[30px] rounded-[20px] lg:mb-0">
        <Image
          src={thumbnail ?? '/store/save-20-percent.jpg'}
          width={700}
          height={700}
          alt=""
          className="rounded-md object-fill"
        />

        <div className="absolute inset-0 flex items-center justify-center">
          <button onClick={() => setIsOpen(true)} className="">
            <div className="relative flex h-[66.54px] w-[66.54px] items-center justify-center rounded-full bg-white bg-opacity-30 text-primary-700 hover:text-white lg:h-[130px] lg:w-[130px] lg:bg-transparent lg:bg-opacity-100 lg:bg-[url('/video-play-bg.png')]">
              <Play />
            </div>
          </button>
        </div>
      </div>
      <HeadlessModal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        dialogPanelClassName="!min-h-min !w-11/12 md:!max-w-[725px] !p-0 !rounded-[10px] !bg-transparent"
        dialogCloseBtnClassName="!hidden"
      >
        <div className="">
          <ReactPlayer
            url={videoUrl ?? 'https://www.youtube.com/watch?v=Z008JPQU66c'}
            playing={true}
            height="405px"
            width="720px"
          />
        </div>
      </HeadlessModal>
    </>
  );
}
